/* lib/useViewParam.js — URL-backed "where am I" (2026-08-24 mandate: a
 * refresh must land where the user was). Drop-in for useState on any tab /
 * view / section id: the value IS the URL, so refresh, Back/Forward and a
 * pasted link all agree. Writes use replace:true so the history is not
 * spammed, and every other search param is preserved verbatim.
 * Kept OUT of lib/viewState.js on purpose: that module must stay importable
 * from files (and tests) that have no router. */
import { useCallback, useRef } from "react";
import { useSearchParams } from "react-router-dom";

export function useViewParam(key, fallback, allowed) {
  const [params, setParams] = useSearchParams();
  const raw = params.get(key);
  const value = (raw != null && (!allowed || allowed.indexOf(raw) >= 0)) ? raw : fallback;
  const valueRef = useRef(value);
  valueRef.current = value;
  const set = useCallback((next) => {
    const v = typeof next === "function" ? next(valueRef.current) : next;
    setParams((prev) => {
      const p = new URLSearchParams(prev);
      if (v == null || v === fallback) p.delete(key); else p.set(key, String(v));
      return p;
    }, { replace: true });
  }, [key, fallback, setParams]);
  return [value, set];
}

export default useViewParam;
